<template>
  <div class="nav_container">
    <div class="nav_icon" @click="()=>{this.$router.push('/home')}">
      <img :src="logo" class="nav_logo" alt="">
      <span>硕麒ERP系统</span>
    </div>

    <div class="usr_icon">
      <div class="user-avatar">{{this.$store.getters.nickName}}</div>
      <div class="icon-container">
        <img :src="changePwd" class="icon" @click="()=>{this.dialogVisible=true}" alt="">
        <img :src="logout" class="icon" @click="goLogout" alt="">
      </div>
      <el-dialog
          title="修改密码"
          :visible.sync="dialogVisible" width="50%">
        <el-form label-width="150px" style="width: 80%" :model="form" :rules="rules" ref="form" size="small">
          <el-form-item label="输入旧密码" required prop="oldpassword">
            <el-col>
              <el-input placeholder="请输入旧密码" v-model="form.oldpassword" show-password></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="设置新密码" required prop="password">
            <el-input placeholder="请输入旧密码" v-model="form.password" show-password></el-input>
          </el-form-item>
          <el-form-item label="再次的输入新密码" required prop="newpassword">
            <el-input placeholder="请输入旧密码" v-model="form.newpassword" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="handleModifyPass('form')">确认修改</el-button>
          </el-form-item>

        </el-form>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import logo from '@/assets/images/logo2.png';
import logout from '@/assets/images/logout.svg';
import changePwd from '@/assets/images/changePwd.svg';
import {modePwd} from "@/api/login";
import {mapGetters} from "vuex";
export default {
  name: "index",
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.form.newpassword !== '') {
          this.$refs.form.validateField('newpassword')
        }
        callback()
      }
    }
    return {
      logo,
      logout,
      changePwd,
      dialogVisible: false,
      form: {
        oldpassword: '',
        password: '', // 新密码
        newpassword: ''
      },
      rules: {
        oldpassword: [
          {required: true, message: '请输入旧密码', trigger: 'blur'},
        ],
        password: [
          {min: 7, max: 16, message: '请输入7-16位密码，包含数字和字母，字母区分大小写', trigger: 'blur'},
          {validator: validatePass, trigger: 'blur'}
        ],
        newpassword: [
          {validator: validatePass2, trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'avatar'
    ])
  },
  methods: {
    handleModifyPass(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          modePwd(this.form).then(response => {
            if (response.code === 200) {
              this.$message({
                message: "密码修改成功，请重新登录",
                type: 'success',
                duration:1000
              });
              this.logout()
            }
          })
        }
      })
    },

    goLogout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "ALiMaMa";
  src: url("//at.alicdn.com/wf/webfont/iovYC5mWxv8m/L719MwqKOE65.woff2") format("woff2"),
url("//at.alicdn.com/wf/webfont/iovYC5mWxv8m/qNPeJh19iuxh.woff") format("woff");
  font-display: swap;
}
.nav_container{
  height: 56px;
  background: #FFFFFF;
  box-shadow: 0 2px 10px 0 rgba(23,24,26,0.08);
  border-radius: 0;
  display: flex;
  justify-content: space-between;
  .nav_icon{
    cursor: pointer;
    width: 300px;
    display: flex;
    align-items: center;
    .nav_logo{
      height: 28px;
      margin-left: 27px;
      margin-right: 5px;
    }
    span{
      height: 32px;
      font-family: ALiMaMa,Microsoft YaHei, serif;
      font-weight: 400;
      font-size: 22px;
      color: #3D3D3D;
      line-height: 33px;
      text-align: left;
      letter-spacing: 0;
    }
  }
  .usr_icon{
    margin-right: 2vw;
    display: flex;
    align-items: center;
    .user-avatar{
      margin-right: 30px;
    }
    .icon-container{
      width: 80px;
      display: flex;
      justify-content: space-between;
      .icon{
        cursor: pointer;
        width: 21px;
        height: 21px;
      }
    }
  }
}
</style>
